module.exports = __webpack_public_path__ + "img/swiper6.72b0ab3d.jpg";